import { useState } from 'react';

import { useServerClient, configuration as _configuration } from '../useServerClient';
import { useServerParams } from '../useServerParams';

import { schedulerConfigs } from './useSchedulers';

export const configuration = _configuration

export const repositoryTypes = {
    container: "container",
    package: "package"
}

export const actionTypes = {
    modify: "modify"
}

export const targetTypes = {
    container: "container",
    package: "package"
}

export function useRepositories({
    repositoryType: _repositoryType,
    targetType: _targetType,
    actionType: _actionType
}) {

    const [repositoryType, setRepositoryType] = useState(_repositoryType);
    const [targetType, setTargetType] = useState(_targetType)
    const [actionType, setActionType] = useState(_actionType)

    const { makeCall, serverClient, getError } = useServerClient();
    const { getListsUrl, getUrlWithDataTypes, _operatorDef: filterOperatorTypes } = useServerParams();

    const [isLoading, setIsLoading] = useState(false)

    const endpoint = "repositories";
    const endpoint2 = "repository";

    const list = async (props) => {

        setIsLoading(true);

        // option for configuration
        let configuration = props?.configuration

        try {

            let { repositoryType: overrideRepositoryType } = props

            let url = getListsUrl(`${endpoint}/${repositoryType}`, props)

            if (overrideRepositoryType) {
                url = getListsUrl(`${endpoint}/${overrideRepositoryType}`, props)
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {},
                configuration
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            // setIsLoading(false);
            // throw error;
            if (!serverClient.isCancel(error)) {
                setIsLoading(false);
                throw error;
            } else {
                setIsLoading(true);
            }

        }

        return true

    }

    const create = async ({ data, skipSchedulerRequestSubmit = false }) => {

        setIsLoading(true)

        try {

            const url = endpoint2;

            let payload = data

            if (skipSchedulerRequestSubmit === false) {
                // adding the scheduler request
                payload = {
                    ...payload,
                    ...schedulerConfigs.getSchedulerRequestSubmitObject(schedulerConfigs.schedulerIntegrations)
                }
            }

            let postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload
            }

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const update = async ({
        id,
        data,
        targetType: overrideTargetType,
        actionType: overrideActionType,
        skipSchedulerRequestSubmit = false
    }) => {

        setIsLoading(true)

        try {

            const url = `${endpoint2}/${id}`

            let payload = data

            if (skipSchedulerRequestSubmit === false) {
                // adding the scheduler request
                payload = {
                    ...payload,
                    ...schedulerConfigs.getSchedulerRequestSubmitObject(schedulerConfigs.schedulerIntegrations)
                }
            }

            let postData = {
                scope: {
                    target: targetType,
                    action: actionType,
                },
                payload
            }

            // console.log('data', data)

            if (overrideTargetType) postData.scope.target = overrideTargetType
            if (overrideActionType) postData.scope.action = overrideActionType

            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }


    // const modify = async ({ id, data }) => {

    //     setIsLoading(true)

    //     try {

    //         const url = `${endpoint2}/${id}`

    // adding the scheduler request
    // let payload = {
    //     ...data,
    //     ...schedulerConfigs.getSchedulerRequestSubmitObject(schedulerConfigs.schedulerIntegrations)
    // }

    //         let postData = {
    //             scope: {
    //                 target: targetType,
    //                 action: "",
    //             },
    //             payload: data
    //         }

    //         const response = await makeCall({
    //             url,
    //             method: "PUT",
    //             payload: postData
    //         });

    //         setIsLoading(false);

    //         return response;

    //     } catch (error) {

    //         setIsLoading(false);
    //         throw error;

    //     }

    // }

    const remove = async ({ ids, skipSchedulerRequestSubmit = false }) => {

        setIsLoading(true);

        if (ids.length <= 0) {
            throw getError(false, `Please select at least (1) items`)
        }

        try {

            // let url = `${endpoint}/${repositoryType}/delete`
            let url = `${endpoint}/delete`

            let payload = {
                ids
            }

            if (skipSchedulerRequestSubmit === false) {
                // adding the scheduler request
                payload = {
                    ...payload,
                    ...schedulerConfigs.getSchedulerRequestSubmitObject(schedulerConfigs.schedulerIntegrations)
                }
            }

            const postData = {
                scope: {
                    target: targetType
                },
                payload
            }

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const get = async ({ id, repositoryType: overrideRepositoryType = '', dataTypesArray = [] }) => {

        setIsLoading(true);

        try {

            let url = getUrlWithDataTypes(`${endpoint2}/${repositoryType}/${id}`, dataTypesArray);

            if (overrideRepositoryType) {
                url = getUrlWithDataTypes(`${endpoint2}/${overrideRepositoryType}/${id}`, dataTypesArray);
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    return {
        isLoading,
        filterOperatorTypes,
        list,
        get,
        create,
        update,
        // modify,
        remove
    }
}